module.exports = __webpack_public_path__ + "static/img/produce15.f3ba814.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce15.png
// module id = 145
// module chunks = 4